import { atom } from 'jotai'

import {
	cornerDotColorAtom,
	cornerDotStyleAtom,
	cornerFrameColorAtom,
	cornerFrameStyleAtom,
} from '../pages/QrDesignFormPage/CornersDesignForm'
import {
	frameBackgroundColorAtom,
	frameColorAtom,
	frameTextAtom,
	frameTextColorAtom,
	frameTypeAtom,
} from '../pages/QrDesignFormPage/FrameDesignForm'
import {
	qrLogoImageAtom,
	qrSelectedLogoUrlAtom,
} from '../pages/QrDesignFormPage/LogoDesignForm'
import {
	patternAtom,
	qrBackgroundColorAtom,
	qrDotColorAtom,
} from '../pages/QrDesignFormPage/PatternDesignForm'
import type { TQrDesign } from '../services/types'

export const qrPreviewDesignAtom = atom<TQrDesign>(
	(get) =>
		({
			frame: {
				type: get(frameTypeAtom),
				text: get(frameTextAtom),
				textColor: get(frameTextColorAtom),
				color: get(frameColorAtom),
				background: get(frameBackgroundColorAtom),
			},
			dotsOptions: {
				type: get(patternAtom),
				color: get(qrDotColorAtom),
			},
			backgroundOptions: {
				color: get(qrBackgroundColorAtom),
			},
			cornersSquareOptions: {
				type: get(cornerFrameStyleAtom),
				color: get(cornerFrameColorAtom),
			},
			cornersDotOptions: {
				type: get(cornerDotStyleAtom),
				color: get(cornerDotColorAtom),
			},
			image: {
				selected: get(qrSelectedLogoUrlAtom),
				uploaded: get(qrLogoImageAtom),
			},
		}) as TQrDesign,
)
